import React from 'react';
import { translate } from '@utils/i18n';
const namespace = 'features.settings.service_trade';
export default function OfficeSelector({ offices, selectedOfficeIds, onChange }) {
    // null or all offices selected = "Select All"
    const allSelected = selectedOfficeIds === null || (selectedOfficeIds.length === offices.length && offices.length > 0);
    const handleToggleAll = () => {
        if (allSelected) {
            // Deselect all (empty array, not null - forces user to make a selection)
            onChange([]);
        }
        else {
            // Select all = null (will sync all offices including future ones)
            onChange(null);
        }
    };
    const handleToggleOffice = (officeId) => {
        // If null (all selected), convert to array excluding this office
        if (selectedOfficeIds === null) {
            const allIds = offices.map(o => o.id);
            onChange(allIds.filter(id => id !== officeId));
            return;
        }
        if (selectedOfficeIds.includes(officeId)) {
            onChange(selectedOfficeIds.filter(id => id !== officeId));
        }
        else {
            onChange([...selectedOfficeIds, officeId]);
        }
    };
    if (offices.length === 0) {
        return (React.createElement("div", { className: "office-selector office-selector--empty" },
            React.createElement("p", null, translate('office_selector.no_offices', { namespace }))));
    }
    return (React.createElement("div", { className: "office-selector" },
        React.createElement("div", { className: "office-selector__header" },
            React.createElement("label", { className: "office-checkbox" },
                React.createElement("input", { type: "checkbox", checked: allSelected, onChange: handleToggleAll }),
                React.createElement("span", { className: "office-checkbox__label" },
                    React.createElement("strong", null, translate('office_selector.select_all', { namespace })))),
            React.createElement("span", { className: "office-count" }, allSelected
                ? translate('office_selector.all_selected', { namespace })
                : translate('office_selector.selected_count', { namespace, count: (selectedOfficeIds === null || selectedOfficeIds === void 0 ? void 0 : selectedOfficeIds.length) || 0, total: offices.length }))),
        React.createElement("div", { className: "office-selector__list" }, offices.map((office) => (React.createElement("label", { key: office.id, className: "office-checkbox" },
            React.createElement("input", { type: "checkbox", checked: selectedOfficeIds === null || selectedOfficeIds.includes(office.id), onChange: () => handleToggleOffice(office.id) }),
            React.createElement("span", { className: "office-checkbox__label" },
                React.createElement("strong", null, office.name),
                office.address && React.createElement("span", { className: "office-address" }, office.address))))))));
}
